module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-rain-5f95c8a3.svg";